import { X, FileText, FolderTree, ImageIcon, Link2 } from 'lucide-react';
import type { Attachment } from '@/lib/agents/types';

const ICONS: Record<Attachment['kind'], React.ComponentType<{ className?: string }>> = {
  file: FileText,
  folder: FolderTree,
  image: ImageIcon,
  url: Link2,
};

interface Props {
  attachments: Attachment[];
  onRemove?: (id: string) => void;
}

export function AttachmentChips({ attachments, onRemove }: Props) {
  if (!attachments.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5 px-1 pb-1.5">
      {attachments.map((a) => {
        const Icon = ICONS[a.kind];
        return (
          <span
            key={a.id}
            className="inline-flex items-center gap-1 rounded-md border border-border bg-surface px-2 py-0.5 text-[12px] text-fg-muted"
          >
            <Icon className="h-3 w-3" />
            <span className="max-w-[180px] truncate">{a.name}</span>
            {onRemove && (
              <button
                type="button"
                onClick={() => onRemove(a.id)}
                className="focus-ring rounded p-0.5 text-fg-subtle hover:text-fg"
                aria-label={`Remove ${a.name}`}
              >
                <X className="h-3 w-3" />
              </button>
            )}
          </span>
        );
      })}
    </div>
  );
}
